import { useParams } from "react-router-dom";
import { Alert, Button, Card } from "@mui/material";
import VetMap, { VetMapUnavailable } from "../VetProfile/VetMap";
import GoBackCommon from "@fuse/core/GoBackCommon/GoBackCommon";
import VetInfoCard from "../VetInfoCard/VetInfoCard";
import { IVetModel } from "@fuse/models";
import { vetProfileDetails } from "../../vetProfile.logic";
import useVetProfile from "../../useVetProfile";

function VetInfoCards({ vet }: { vet: IVetModel }) {
	const { detail, coordinates, openingHours } = vetProfileDetails(vet, process.env.VITE_APP_GOOGLE);
	return (
		<>
			<Card className="w-full p-[28px]">
				<VetInfoCard detail={detail} />
			</Card>
			<div className="w-full flex sm:flex-row flex-col gap-[20px]">
				<Card className="w-full sm:w-1/2 p-[28px] flex flex-col gap-[20px]">
					<h2 className="font-700 sm:text-[22px] text-[18px]">More Information</h2>
					<div className="flex flex-col gap-[4px]">
						<h3 className="font-700 sm:text-[16px] text-[14px]">Business Hours</h3>
						{openingHours.length ? openingHours.map((hours, index) => (
							<div className="flex gap-[20px] text-[14px] sm:text-[16px]" key={`${hours.day}-${index}`}>
								<p className="w-1/3">{hours.day}</p>
								<p className="flex-1">{hours.time}</p>
							</div>
						)) : <p>Business hours unavailable.</p>}
					</div>
					<div className="flex flex-col gap-[4px]">
						<h3 className="font-700 sm:text-[16px] text-[14px]">Website</h3>
						<p className="break-words text-[14px] sm:text-[16px]">{detail.website || "Website unavailable."}</p>
					</div>
				</Card>
				<Card className="w-full sm:w-1/2 min-h-[260px] sm:h-[360px] flex flex-col">
					{coordinates ? <VetMap lat={coordinates.latitude} lng={coordinates.longitude} vetName={detail.name} /> : <VetMapUnavailable />}
				</Card>
			</div>
		</>
	);
}

export default function VetInfo() {
	const { id } = useParams();
	const { vet, loading, error, retry } = useVetProfile(id);
	return (
		<div className="flex flex-col w-full p-[20px] gap-[20px]">
			<GoBackCommon />
			{loading && <p role="status">Loading veterinarian...</p>}
			{error && <Alert severity="error" action={<Button color="inherit" onClick={retry}>Retry</Button>}>{error}</Alert>}
			{vet && <VetInfoCards vet={vet} />}
		</div>
	);
}
